import { graphql } from "msw";
import { mockCart, mockCartOrderSummary } from "../cart/mockCart";
import {
  ToggleDonationMutationVariables,
  ToggleDonationMutation,
} from "@cart-app/generated/graphql";

export const handler = graphql.mutation<
  ToggleDonationMutation,
  ToggleDonationMutationVariables
>("ToggleDonation", (req, res, ctx) => {
  const { add } = req.variables;
  let totalAmount = 16910;
  if (add) {
    totalAmount = 17000;
  }
  return res(
    ctx.data({
      toggleDonation: {
        __typename: "Cart",
        ...mockCart,
        orderSummary: {
          ...mockCartOrderSummary,
          totalPrice: {
            __typename: "Money",
            amount: totalAmount,
            currency: "AUD",
          },
        },
      },
    })
  );
});
